"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AndroidInfo = (function () {
    function AndroidInfo(window) {
        this.window = window;
        this.android = window.Android;
        this.deviceType = 'Console';
        this.userFriendlyName = 'AndroidTV';
        this.deviceVersion = this.android.getDevice();
        this.deviceBrand = this.android.getBrand();
        this.browserName = this.window.navigator.userAgent;
        this.browserVersion = this.window.navigator.userAgent;
        this.deviceModel = this.android.getModel();
        this.deviceManufacturer = this.android.getManufacturer();
        this.operatingSystemName = this.window.navigator.platform;
        this.operatingSystemVersion = this.window.navigator.appVersion;
        this.uniqueDeviceId = this.android.getDeviceId();
        this.containerVersion = this.android.getVersion();
    }
    return AndroidInfo;
}());
exports.AndroidInfo = AndroidInfo;
